import React, { useState } from "react";
import {
  Box,
  makeStyles,
  Typography,
  Button,
  Grid,
  Input,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    // height: "100%",
  },

  stepper: {
    // backgroundImage: "linear-gradient(#D4D4D4 50%, rgba(255,255,255,0) 0%)",
    // backgroundPosition: "left",
    // backgroundSize: "3px 20px",
    // backgroundRepeat: "repeat-y",
    position: "relative",
    flex: 1,
    overflow: "hidden",
  },

  stepperContent: {
    display: "flex",
    alignItems: "center",
    flex: 1,
  },
  completed: {
    color: "#1ED059",
    fontSize: "10px",
    marginTop: "2rem",
  },
  stepperIcon: {
    width: "3rem",
    height: "3rem",

    marginRight: 7,

    backgroundColor: "#1ED059",
    borderRadius: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  dullStepperIcon: {
    width: "3rem",
    height: "3rem",

    marginRight: 7,

    backgroundColor: "#D4D4D4",
    borderRadius: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  stepperIconText: {
    fontWeight: "500",
    fontSize: "1.2rem",
    lineHeight: "1.4rem",
    color: "#EFF4FB",
  },

  stepperText: {
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "1.7rem",
    color: "#000000",
    marginBottom:"3px"
  },

  stepperPath: {
    height: "100%",
    width: 10,
    borderLeft: "3px dashed #D4D4D4",
    position: "absolute",
    left: "-1000px",
  },
  dottedBox: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "13px",
  },
  dot: {
    backgroundColor: "#1ed059",
    height: "10px",
    width: "3px",
    borderRadius: "57px",
    margin: "3px 0px",
  },
}));

const Stepper = ({ name, count, currentStep }) => {
  const classes = useStyles();
  console.log({ currentStep });

  return (
    <Box className={classes.stepper}>
      <Box className={classes.stepperContent}>
        <Box
          className={
            currentStep >= count ? classes.stepperIcon : classes.dullStepperIcon
          }
        >
          <Typography className={classes.stepperIconText}>{count}</Typography>
        </Box>
        <Box>
          <Typography className={classes.stepperText}>{name}</Typography>

          {currentStep >= count + 1 ? (
            <span className={classes.completed}> Completed</span>
          ) : null}
        </Box>
      </Box>
      <Box className={classes.stepperPath}></Box>
    </Box>
  );
};

export default Stepper;
